export default __webpack_public_path__ + "static/media/coupon_sent_on.4763be68.png";